import learningApi from '@src/services/api/learning/index'

export default learningApi.defineApi([

  /*
   * 新規登録関連
   */
  // 利用者新規登録
  {
    name: 'postUserSingup',
    method: 'post',
    url: '/user/signup'
  },
  {
    name: 'patchUserSingup',
    method: 'patch',
    url: '/user/signup'
  },

  /*
   * 利用者情報関連
   */
  // マイ利用者 取得
  {
    name: 'getUser',
    method: 'get',
    url: '/my/user'
  },
  // マイ利用者 変更
  {
    name: 'putUser',
    method: 'put',
    url: '/my/user'
  },
  // マイ利用者 退会
  {
    name: 'sendResign',
    method: 'post',
    url: '/my/user/resign'
  },
  // 利用者 パスワード変更
  {
    name: 'editPasswrod',
    method: 'put',
    url: '/my/user/password'
  },
  // 利用者 メールアドレス変更
  {
    name: 'editMailAddress',
    method: 'put',
    url: '/my/user/email'
  },
  // 利用者 メールアドレス変更有効化
  {
    name: 'patchMailAddress',
    method: 'patch',
    url: '/my/user/email'
  },
  // 利用者 アカウントリマインダー
  {
    name: 'sendAccountReminder',
    method: 'post',
    url: '/my/user/reminder/identifier'
  },
  // 利用者 パスワードリマインダー
  {
    name: 'sendReminder',
    method: 'post',
    url: '/my/user/reminder/password'
  },
  // 利用者 パスワードリマインダー認証
  {
    name: 'putReminder',
    method: 'put',
    url: '/my/user/reminder/password'
  },
  // 利用者 問い合わせ（ログイン済み）
  {
    name: 'postInquiry',
    method: 'post',
    url: '/my/user/inquiry'
  },

  // 利用者 問い合わせ（ゲスト）
  {
    name: 'postInquiryGeust',
    method: 'post',
    url: '/my/guest/inquiry'
  },

  /*
   * 講座関連
   */
  // マイ利用者 講座一覧
  {
    name: 'getTrainee',
    method: 'get',
    url: '/my/user/trainees'
  },
  // マイ利用者 講座予約
  {
    name: 'postTrainee',
    method: 'post',
    url: '/my/user/trainees'
  },
  // マイ利用者 予約講座詳細
  {
    name: 'getTraineeDetail',
    method: 'get',
    url: '/my/user/trainees/:traineeId'
  },
  // マイ利用者 講座決済
  {
    name: 'postTraineePay',
    method: 'post',
    url: '/my/user/trainees/:traineeId/pay'
  },
  // マイ利用者 講座申込みキャンセル
  {
    name: 'deleteTraineeCancel',
    method: 'delete',
    url: '/my/user/trainees/:traineeId'
  },
  // 予約講座 オンデマンド受講開始
  {
    name: 'postTraineeOnlineStart',
    method: 'post',
    url: '/my/user/trainees/:traineeId/start'
  },
  // 予約講座 オンデマンド受講終了
  {
    name: 'postTraineeOnlineEnd',
    method: 'post',
    url: '/my/user/trainees/:traineeId/end'
  },
  // 予約講座 領収書発行
  {
    name: 'postTraineeReceipt',
    method: 'post',
    url: '/my/user/trainees/:traineeId/receipt'
  },
  // アンケート回答
  {
    name: 'postTraineeQuestionnaire',
    method: 'post',
    url: '/my/user/trainees/:traineeId/questionnaire'
  },
  // 予約講座 修了証発行
  {
    name: 'postTraineeCert',
    method: 'post',
    url: '/my/user/trainees/:traineeId/cert'
  }
])
